import { render } from "./edit-support-case.vue?vue&type=template&id=2a7aa980&scoped=true"
import script from "./edit-support-case.vue?vue&type=script&lang=js"
export * from "./edit-support-case.vue?vue&type=script&lang=js"

import "./edit-support-case.vue?vue&type=style&index=0&id=2a7aa980&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7aa980"]])

export default __exports__